import * as __vanilla_filescope__ from '@vanilla-extract/css/fileScope';
__vanilla_filescope__.setFileScope("src/styles.css.ts", "@paypalcorp/pp-react-screen-reader");
import { style as _style } from '@vanilla-extract/css';
function style(rule, debugId) {
  return [_style(rule, debugId), rule];
}
export const [screenReader, screenReaderStyles] = style({
  position: 'absolute',
  clip: `rect(1px, 1px, 1px, 1px)`,
  padding: 0,
  border: 0,
  width: '1px',
  height: '1px',
  overflow: 'hidden'
}, 'screenreader');
__vanilla_filescope__.endFileScope();
